import isNil from 'lodash/isNil';
import useDashboardSelector from '../../redux/selectorHooks/useDashboardSelector';
import { useCurrentUrl } from '../../utils/routing';
import { useAiExplainFeature } from '../../utils/hooks';

export const useShowLumos = () => {
  const { isReportInUrl, isCohortsInUrl, isViewCohortInUrl } = useCurrentUrl();
  const explainWithAiFeatureEnabled = useAiExplainFeature();

  return (
    (isReportInUrl || (isCohortsInUrl && !isViewCohortInUrl)) &&
    explainWithAiFeatureEnabled
  );
};

export const useShowComments = () => {
  // Comments are available only for Dashboard Instance
  const dashboard = useDashboardSelector('dashboard');
  const { isDashboardInUrl } = useCurrentUrl();

  return !isNil(dashboard) && isDashboardInUrl;
};
